import Udesk from 'Udesk';
import { getRouteNameWithNameSpace } from "Udesk/system/subApp";

export const getRouteNameWithCoach = getRouteNameWithNameSpace(Udesk.enums.sysModuleList.coach.nameSpace);
